// @file Vue composable for all menu+panel related logic in Slideshow

import { useSlideshowStore } from '@@/pinia/slideshow'
import { storeToRefs } from 'pinia'

export const useSlideshowOverlays = (): {
  isAnyOverlayOpen: typeof isAnyOverlayOpen
  isAutoplayMenuOpen: typeof isAutoplayMenuOpen
} => {
  const { isAnyOverlayOpen, isAutoplayMenuOpen } = storeToRefs(useSlideshowStore())

  return {
    isAnyOverlayOpen,
    isAutoplayMenuOpen,
  }
}
